import { EmailOutlineIcon } from './EmailOutlineIcon';

/**
 * author: Google
 * id 53CE3621-DBCC-45E8-B105-2BEA7493CCA0
 * name email-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-outline.svg
 * tags
 */
export const MailOutlineIcon = EmailOutlineIcon;
export default MailOutlineIcon